<template>
  <div>
    <BaseCardHeader class="hidden md:block mb-1 dreamCardListHeader">
      <h3>
        {{ l('dreamPage.best.title') }}
      </h3>
    </BaseCardHeader>
    <transition :name="transition">
      <BaseFlex
        v-if="!pending || !transition"
        class="dreamCardList"
        direction="column"
        gap="medium"
      >
        <DestinationPickerCardListItem
          v-for="(item, i) in props.items"
          :key="item.country_id"
          :item="item"
          :index="i + 1"
          :round="(i !== 0 && $breakpoints.lSm) || ($breakpoints.sMd)"
          :user-preference="props.userPreference"
        />
      </BaseFlex>
    </transition>
  </div>
</template>

<script setup>
const props = defineProps({
	items: {
		type: Array,
		default: () => []
	},
	userPreference: {
		type: Array,
		required: true
	},
	pending: {
		type: Boolean,
		default: true
	},
	transition: {
		type: String,
		default: ''
	}
});
import { l } from '@utils/toolbox';
import BaseCardHeader from '../Base/BaseCardHeader.vue';
import BaseFlex from '../Base/BaseFlex.vue';

</script>

<style scoped>
.img-container {
  height: 0;
  padding-bottom: 56.25%;
  position: relative;
  width: 100%;
}
.img {
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  position: absolute;
  width: 100%;
}
.dreamCardList {
  margin-top: -3px;
}
@media (max-width: 767.8px) {
  .dreamCardList {
    gap: var(--spacer-xlarge) !important;
  }
}
.dreamCardListHeader {
  border-top-left-radius: 0.9rem;
  border-top-right-radius: 0.9rem;
}
a {
  color: inherit;
  text-decoration: none;
}
</style>
